// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_c6-b";
export var colorBlue = "_c6-8";
export var colorDot = "_c6-0";
export var colorDotLarge = "_c6-2";
export var colorDotSmall = "_c6-1";
export var colorGreen = "_c6-7";
export var colorGrey = "_c6-3";
export var colorOrange = "_c6-5";
export var colorPink = "_c6-a";
export var colorPurple = "_c6-9";
export var colorRed = "_c6-4";
export var colorYellow = "_c6-6";